import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { StButton } from './IconButton.styled'

import type { FC } from 'react'
import type { IconButtonProps } from './IconButton.types'

const IconButton: FC<IconButtonProps> = ({ variant, isLoading, icon, size, color, ...inheritedProps }) => {
  return (
    <StButton role='button' variant={variant} size={size} {...inheritedProps}>
      {isLoading ? (
        <FontAwesomeIcon spin icon={['fad', 'loader']} />
      ) : (
        <FontAwesomeIcon icon={icon} size={size === 'small' ? 'xs' : 'lg'} color={color} />
      )}
    </StButton>
  )
}

export { IconButton }
